import React from 'react';
import classnames from 'classnames';
import Box from './../Box/Box';

import styles from './Skeleton.module.scss';

type Theme = 'dark' | 'light';

interface SkeletonWidth {
  xs?: number;
  md?: number;
  xl?: number;
}

export interface SkeletonProps {
  width?: SkeletonWidth;
  height?: string;
  borderRadius?: string;
  className?: string;
  theme?: Theme;
  shouldScale?: boolean;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width = { xs: 40, md: 60, xl: 80 },
  height = '20px',
  borderRadius = '8px',
  className,
  theme = 'dark',
  shouldScale = false,
}) => {
  const classList: string[] = [];

  for (const w in width) {
    const breakpoint = w as keyof SkeletonWidth;
    const widthValue = width[breakpoint];
    if (widthValue !== undefined) {
      classList.push(styles[`w-${w}-${widthValue}`]);
    }
  }

  return (
    <Box
      className={classnames(
        styles.skeleton,
        styles[theme],
        ...classList,
        {
          [styles.scale]: shouldScale,
        },
        className
      )}
      // eslint-disable-next-line react/forbid-component-props
      style={{ height, borderRadius }}
    >
      &nbsp;
    </Box>
  );
};

Skeleton.displayName = 'Skeleton';

export default Skeleton;
